import { render, staticRenderFns } from "./UnderDevelopment.vue?vue&type=template&id=65496f87&scoped=true"
import script from "./UnderDevelopment.vue?vue&type=script&lang=js"
export * from "./UnderDevelopment.vue?vue&type=script&lang=js"
import style0 from "./UnderDevelopment.vue?vue&type=style&index=0&id=65496f87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65496f87",
  null
  
)

export default component.exports